import UsersList from "@/core-modules/users/UsersList";
import { User } from "@/interface/entityInterface";

const UserRolesList = () => {
  return (
    <UsersList
      costumCols={[
        {
          accessorFn: ({ row }: { row: User }) => row?.branches?.name || "",
          id: "branch",
          accessorKey: "branch_id",
          header: "Branch assigned",
          cell: ({ row }: any) => (
            <div>{row.original?.branches?.name || ""}</div>
          ),
        },
      ]}
      roles={[
        { label: "Owner", value: "owner" },
        { label: "Manager", value: "manager" },
        { label: "Mechanic", value: "mechanic" },
        { label: "Accountant", value: "accountant" },
      ]}
    />
  );
};

export default UserRolesList;
